export default __webpack_public_path__ + "static/media/change-password.fe166ab1.svg";